module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-tit"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-line"
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("PART 1. “Moving” Images")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1"
    }
  }, [_vm._v("1 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  Images of the Prophet Muhammad "), _c('em', [_vm._v("In and Out")]), _vm._v(" of Modernity:"), _c('br'), _vm._v("The Curious Case of a 2008 Mural in Tehran")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Christiane Gruber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  Secular Domesticities, Shiite Modernities:"), _c('br'), _vm._v("Khomeini’s Illustrated "), _c('em', [_vm._v("Tawzih al-Masail")])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Pamela Karimi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  Memory and Ideology:"), _c('br'), _vm._v("Images of Saladin in Syria and Iraq")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Stefan Heidemann")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  “You Will (Not) Be Able to Take Your Eyes Of It!”:"), _c('br'), _vm._v("Mass-Mediated Images and Politico-Ethical Reform in the Egyptian Islamic Revival")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Patricia Kubala")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2. Islamist Iconographies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  The Muslim “Crying Boy” in Turkey:"), _c('br'), _vm._v("Aestheticization and Politicization of Suffering in Islamic Imagination")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Özlem Savaş")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  The New Happy Child in Islamic Picture Books in Turkey")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Umut Azak")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  Sadrabiliyya:"), _c('br'), _vm._v("The Visual Narrative of Muqtada al-Sadr’s Islamist Politics and Insurgency in Iraq")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Ibrahim Al-Marashi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  The Martyr’s Fading Body:"), _c('br'), _vm._v("Propaganda vs. Beautification in the Tehran Cityscape")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Ulrich Marzolph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3. Satirical Contestations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  Pushing Out Islam:"), _c('br'), _vm._v("Cartoons of the Reform Period in Turkey (1923–1928)")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Yasemin Gencer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chg"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  Blasphemy or Critique?:"), _c('br'), _vm._v("Secularists and Islamists in Turkish Cartoon Images")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("John VanderLippe and Pınar Batur")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chg"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  Naji al-Ali and the Iconography of Arab Secularism")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Sune Haugbolle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 4. Authenticity and Reality in Trans-National Broadcasting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chg"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  Arab Television Drama Production and the Islamic Public Sphere")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Christa Salamandra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chg"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v("  Saudi-Islamist Rhetorics about Visual Culture")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "image",
      "src": "images/square.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Marwan Kraidy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contributors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0